var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    width: "24px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51B3DA"
    },
    d: "M290.772,0h-69.544c-11.153,0-20.194,9.042-20.194,20.194s9.042,20.194,20.194,20.194h14.578v37.404 c0,11.153,9.042,20.194,20.194,20.194c11.153,0,20.194-9.042,20.194-20.194V40.389h14.578c11.153,0,20.194-9.042,20.194-20.194 S301.926,0,290.772,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#39A3DB"
    },
    d: "M290.772,0H256v97.987c11.153,0,20.194-9.042,20.194-20.194V40.389h14.578 c11.153,0,20.194-9.042,20.194-20.194S301.926,0,290.772,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEDBE"
    },
    d: "M256,512C130.721,512,28.799,410.078,28.799,284.799S130.723,57.598,256,57.598 S483.201,159.52,483.201,284.799S381.279,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE49C"
    },
    d: "M256,57.598v454.4c125.279,0,227.201-101.922,227.201-227.201S381.279,57.598,256,57.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5E5B"
    },
    d: "M345.808,194.99c-7.885-7.885-20.672-7.885-28.559,0l-58.178,58.18 c-18.809-1.804-34.85,12.976-34.85,31.628c0,17.552,14.228,31.779,31.779,31.779c18.65,0,33.431-16.034,31.628-34.85l58.178-58.18 C353.696,215.662,353.696,202.875,345.808,194.99z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE00"
    },
    d: "M256,152.863c-11.153,0-20.194-9.042-20.194-20.194V91.255c0-11.153,9.042-20.194,20.194-20.194 s20.194,9.042,20.194,20.194v41.413C276.194,143.821,267.153,152.863,256,152.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE00"
    },
    d: "M256,498.537c-11.153,0-20.194-9.042-20.194-20.194v-41.415c0-11.153,9.042-20.194,20.194-20.194 s20.194,9.042,20.194,20.194v41.415C276.194,489.495,267.153,498.537,256,498.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE00"
    },
    d: "M103.871,304.993H62.458c-11.153,0-20.194-9.042-20.194-20.194s9.042-20.194,20.194-20.194h41.415 c11.153,0,20.194,9.042,20.194,20.194S115.025,304.993,103.871,304.993z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF423D"
    },
    d: "M345.808,194.99c-7.885-7.885-20.672-7.885-28.559,0l-58.178,58.18 c-1.011-0.097-2.034-0.151-3.071-0.151v63.56c18.65,0,33.431-16.034,31.628-34.85l58.178-58.18 C353.696,215.662,353.696,202.875,345.808,194.99z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M256,71.061v81.802c11.153,0,20.194-9.042,20.194-20.194V91.255 C276.194,80.103,267.153,71.061,256,71.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M256,416.734v81.803c11.153,0,20.194-9.042,20.194-20.194v-41.415 C276.194,425.776,267.153,416.734,256,416.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M449.544,304.993h-41.414c-11.153,0-20.194-9.042-20.194-20.194s9.042-20.194,20.194-20.194h41.414 c11.153,0,20.194,9.042,20.194,20.194S460.696,304.993,449.544,304.993z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.342a141117fbaff8cbaa1c24063198bd.svg";
export { ForwardRef as ReactComponent };